import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENV } from '../core-ng/injection-token';
import { SurveyList,ListType} from '@hyper-inferno/survey-elements-core';

@Injectable({
  providedIn: 'root',
})
export class SurveyListService {
  private http = inject(HttpClient);
  environment = inject(ENV);

  getList(survey_id: number): Observable<SurveyList[]> {
    return this.http.get<any[]>(
      `${this.environment.consoleApi}/survey-builder/get-lists/${survey_id}`,
    );
  }
  createList(payload: {
    name: string;
    list_type: ListType;
    survey_id: number;
    primary_list_id?:string;
  }): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/create-list`,
      payload,
    );
  }

  updateList(payload: {
    name: string;
    list_id:string;
  }): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/update-list`,
      payload,
    );
  }

    createInstruction(payload: {
      instruction_set_list_id: string;
      list_id: string,
      function: string;
      function_list_id?: string;
      function_question_id?:number;
      type?: string;
      parameter_1?: string;
      parameter_2?: string;
      parameter_3?: string;
      parameter_4?: string;
      parameter_5?: string;
      parameter_6?: string;
    }): Observable<any> {
      return this.http.post(
        `${this.environment.consoleApi}/survey-builder/create-instruction`,
        payload
      );
    }

    addInstructionOptionTarget(
      instructionId: string, 
      optionId: string
    ): Observable<any> {
      return this.http.post(
        `${this.environment.consoleApi}/survey-builder/add-instruction-option-target`,
        { instructionId, optionId }
      );
    }

    getInstructionsByListId(listId: string): Observable<any[]> {
      return this.http.get<any[]>(
        `${this.environment.consoleApi}/survey-builder/get-instructions/${listId}`
      );
    }
    
    getInstructionOptionTargets(instructionId: string): Observable<any[]> {
      return this.http.get<any[]>(
        `${this.environment.consoleApi}/survey-builder/get-instruction-option-targets/${instructionId}`
      );
    }
  deleteInstructions(payload: { instructionIds: string[] }): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/delete-instructions`,
      payload,
    );
  }

  updateInstruction(payload: any): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/update-instruction`,
      payload
    );
  }

  deleteInstructionOptionTargets(instructionId: string): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/delete-instruction-option-targets`,
      { instructionId }
    );
  }
}
